<template>
  <v-switch
    v-if="!ocultar_considerar_estoque_grupo_na_compra_por_filial"
    v-model="CONSIDERAR_ESTOQUE_GRUPO"
    hide-details
    color="#a71830"
    class="ml-3"
    :dark="dark"
  >
    <template #label>
      <span class="pl-2" :class="{'text-white': dark}">Considerar estoque do grupo</span>
    </template>
  </v-switch>
</template>

<script>
export default {
  name: "ConsiderarEstoqueGrupo",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    usar_model_personalizada: Boolean,
    modelValue: Boolean,
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    ocultar_considerar_estoque_grupo_na_compra_por_filial: localStorage.ocultar_considerar_estoque_grupo_na_compra_por_filial === 'S',
  }),
  computed: {
    CONSIDERAR_ESTOQUE_GRUPO: {
      get() {
        if (this.usar_model_personalizada) {
          return this.modelValue;
        }

        return this.$store.getters['CompraDistribuidaPorFilial/get_considerar_estoque_grupo'];
      },
      set(valor) {
        if (this.usar_model_personalizada) {
          this.$emit('update:modelValue', valor);
          return;
        }

        this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo', valor);
      }
    }
  }
}
</script>

<style scoped>

</style>
